import React, { useEffect, useRef, useState } from 'react';
import {
  type ICountdownProps,
  MILLISECONDS_IN_SECOND,
  getSecondsLeft,
  secondsToTime,
} from '@secretescapes/cauldron';
import { Typography, TypographyVariant } from '@secretescapes/falcon';
import { getCountdown } from './Countdown.utils';

export const Countdown = ({ endDate }: ICountdownProps) => {
  const [seconds, setSeconds] = useState(() => getSecondsLeft(endDate));
  const timerRef = useRef<number>();

  useEffect(() => {
    function updateCountdown() {
      const secondsLeft = getSecondsLeft(endDate);

      setSeconds(secondsLeft);

      if (secondsLeft <= 0 && timerRef.current) {
        clearInterval(timerRef.current);
      }
    }

    timerRef.current = window.setInterval(updateCountdown, MILLISECONDS_IN_SECOND);

    // Cleanup on unmount or endDate change
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [endDate]);

  const time = secondsToTime(seconds);

  return <Typography variant={TypographyVariant.bodyBold}>{getCountdown(time)}</Typography>;
};
